import React from 'react';
import { useData } from '../../context/DataContext';
import Product from '../utils/Product';

const Products = () => {
  const { products } = useData();
  const show = ()=> products.map((el,i)=> <Product key={i} {...el} />)
  return (
    <div>
      {show()}
    </div>
  );
};

export default Products;